import { render, staticRenderFns } from "./DiffPanel.vue?vue&type=template&id=483beab0&"
import script from "./DiffPanel.vue?vue&type=script&lang=js&"
export * from "./DiffPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports